export default {
    init() {
        function scheduleCallback(data) {
          $("#passData").html(
            "<tr><td>" +
              data.OrderId +
              "</td><td>" +
              data.PassType +
              "</td><td>" +
              (data.IsValid ? 'Yes' : 'No') +
              "</td><td>" +
              (data.PrePaidPassName === "Ten Ride" ? data.PassUsesRemaining : data.ExpiryDate) +
              "</td></tr>"
          );
        }
        function scheduleCallbackError() {
          $("#passData").html(
            "<tr><td colspan='4'>The serial number you entered could not be found.</td></tr>"
          );
        }
        function getPrePaidPass() {
          $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
              action: 'get_pass',
              serial: $('#serial').val()
            },
            dataType: "json",
            success: function(results) {
              scheduleCallback(results);
              $("#passInfo").show();
            },
            error: function(results) {
              scheduleCallbackError();
              $("#passInfo").show();
            },
          });
        }

        $('#hero form').on('submit', function(e) {
            e.preventDefault();
            getPrePaidPass();
        });
    }
}


// WEBPACK FOOTER //
// ./scripts/routes/services.js